import { useState } from 'react';
import { useAvatarPresign, useUpdateProfile } from '../lib/api';

/**
 * Click-to-upload avatar. Uses /me/avatar to get a presigned PUT URL,
 * uploads JPEG directly to S3, then PATCHes /me with the new key so the
 * profile picks it up on next render.
 */
export function AvatarUpload({ initials, currentKey }: { initials: string; currentKey?: string | null }) {
  const presign = useAvatarPresign();
  const update  = useUpdateProfile();
  const [busy, setBusy] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const handleFile = async (file: File) => {
    if (!file.type.startsWith('image/')) return alert('Please choose an image.');
    setBusy(true);
    try {
      const local = URL.createObjectURL(file);
      setPreviewUrl(local);
      const p = await presign.mutateAsync();
      await fetch(p.url, { method: 'PUT', body: file, headers: { 'Content-Type': 'image/jpeg' } });
      await update.mutateAsync({ avatarS3Key: p.key } as any);
    } finally {
      setBusy(false);
    }
  };

  return (
    <label className="relative inline-block cursor-pointer group">
      <div className="w-20 h-20 rounded-full bg-squishy-primary text-white flex items-center justify-center text-2xl font-bold overflow-hidden">
        {previewUrl ? (
          <img src={previewUrl} alt="" className="w-full h-full object-cover" />
        ) : currentKey ? (
          <img src={`https://squishy-uploads-${import.meta.env.VITE_AWS_ACCOUNT}.s3.amazonaws.com/${currentKey}`} alt="" className="w-full h-full object-cover" />
        ) : (
          initials
        )}
      </div>
      <input
        type="file"
        accept="image/*"
        className="sr-only"
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) handleFile(f);
        }}
      />
      <div className="absolute inset-0 rounded-full bg-black/50 text-white text-xs flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
        {busy ? '…' : 'Change'}
      </div>
    </label>
  );
}
